import { ComponentType, ReactNode, SVGAttributes } from 'react';
import clsx from 'clsx';

import CloseXs from '@/assets/icons/CloseXs';

import chipButtonStyles from './ChipButton.module.css';
import styles from '@/components/UI/Button/Button.module.css';

type ChipButtonProps = {
  icon?: ComponentType<SVGAttributes<SVGSVGElement>>;
  onClick?: () => void;
  label?: ReactNode;
  disabled?: boolean;
  size?: 'small' | 'medium';
  testid?: string;
  transparentHover?: boolean;
  handleOnClose?: () => void;
};
export const ChipButton = ({
  icon: ChipIcon,
  transparentHover,
  onClick,
  label,
  disabled,
  size = 'medium',
  testid,
  handleOnClose,
}: ChipButtonProps) => {
  const iconSize = size === 'small' ? '20px' : '24px';

  return handleOnClose ? (
    <div
      data-testid={testid}
      className={clsx(styles.button, styles.chip, styles[size], {
        [styles.disabled]: disabled,
        [styles.transparentHover]: transparentHover,
      })}
      onClick={onClick}
    >
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        {label}
        {handleOnClose && (
          <CloseXs
            onMouseDown={handleOnClose}
            data-testid='chip-button-close-icon'
            aria-hidden='true'
            className={chipButtonStyles.chipButtonCloseIconStyle}
            fill='var(--tractie-color-content-emphasis)'
            width='24px'
            height='24px'
          />
        )}
      </div>
    </div>
  ) : (
    <button
      type='button'
      data-testid={testid}
      className={clsx(styles.button, styles.chip, styles[size], {
        [styles.disabled]: disabled,
        [styles.transparentHover]: transparentHover,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        {ChipIcon && (
          <ChipIcon
            fill={!disabled ? 'var(--tractie-color-content-emphasis)' : 'var(--tractie-color-content-subtle)'}
            width={iconSize}
            height={iconSize}
            aria-hidden='true'
          />
        )}
        {label}
        {handleOnClose && (
          <CloseXs
            onMouseDown={handleOnClose}
            data-testid='chip-button-close-icon'
            aria-hidden='true'
            className={chipButtonStyles.chipButtonCloseIconStyle}
            fill='var(--tractie-color-content-emphasis)'
            width='24px'
            height='24px'
          />
        )}
      </div>
    </button>
  );
};
